<template>
  <div>
    <div class="card-wrapper">
      <div class="card-container" v-for="card in columns" :key="'in-card' + card.definition">
        <div class="card-container--title">
          <div class="dot" :style="{ backgroundColor: card.dotColor }"></div>
          {{ card.name }}
          <span>({{ card.items.length }})</span>
        </div>
        <hr />

        <kanban-card v-for="task in card.items" :key="'in-card' + task._id" :task="task" />
      </div>
    </div>
  </div>
</template>

<script>
import { kanbanColumns, resolveStatuses } from "@/modules/task/task-settings"; // TKP-119
import KanbanCard from "@cc/task/kanban-card";

export default {
  props: ["tasks"],
  components: { KanbanCard },
  data() {
    return {
      columns: [],

      /////////
    };
  },
  computed: {
    // TKP-119: sütun = organizasyonun durum kaydı (sırayla, özel durumlar dahil); kayıt yoksa sistem varsayılanları
    statuses() {
      const language = this.$store.getters["user/account"]?.language ?? "tr";
      return resolveStatuses(this.$store.getters["taskSettings/statuses"], language, (k) => this.$t(k));
    },
  },

  watch: {
    tasks: { immediate: true, deep: true, handler() { this.rebuild(); } },
    statuses: { handler() { this.rebuild(); } },
  },
  methods: {
    rebuild() {
      this.columns = kanbanColumns(this.statuses, this.tasks || []);
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tasks";
</style>
